import { trackPlanTaskEvent } from './trackPlanTaskEvent';
import { PlanTaskAnalyticEvent } from '../consts';
import { PlanTaskReferencePickerPlugin } from '../types';

export const onAddRelationships: PlanTaskReferencePickerPlugin['onAddRelationships'] =
  (source, entities) => {
    entities.forEach(() =>
      trackPlanTaskEvent(PlanTaskAnalyticEvent.ADD, source.type),
    );
  };
